import { IGetARTableInlineStylesParams} from './ARTable.interfaces';

export const getARTableInlineStyles = (params: IGetARTableInlineStylesParams) => {
  return {
    width: params.width || '100%',
    minWidth: params.minWidth || '768px',
    maxWidth: params.maxWidth || '1280px',
  };
};
